module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAUCAMAAABcfiZ7AAAAAXNSR0IB2cksfwAAAEtQTFRFAAAA3+Tk3+Pl3+Pl3+Pl3+Pn3+Ll3uLk3+Pk3+Lm3+Pl3+fn3+Tm3uPl3+Pk3+Pk3+Ll3+Pl3+Pk3+Ll3+Lm3+/v3+Lk3+Pn3+TkgwdBWAAAABl0Uk5TAGDP/69AsPCQUIAgcODQwJ9/v9+gEI8/MAG3KYYAAAB3SURBVHicdY3bDoMgEAUPHuUiINVi2///0sYKSLZxXjaZ7M4CP9RAjhMutLFOaaomZuOPEeirieGci62GpWBTERPr9a1xD64n23M92tmkDjr462WJt0hrFrOPQRhFyp2ohUGa/4zswMtfFRUB83p3DBn4LOzI+xdV9wW0p7lVkQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/assets/img/lock-i.png
// module id = ../../../../../src/assets/img/lock-i.png
// module chunks = main